import { OrderParams } from "./order_params";

export const getStartDateFromOrderParams = (
  params: OrderParams | undefined
): string | undefined => {
  if (!params || !("dateRange" in params) || !params.dateRange) {
    return undefined;
  }
  const dateRange = params.dateRange;
  if ("date" in dateRange) {
    return dateRange.date;
  }
  return "startDate" in dateRange ? dateRange.startDate : undefined;
};

export const getEndDateFromOrderParams = (
  params: OrderParams | undefined
): string | undefined => {
  if (!params || !("dateRange" in params) || !params.dateRange) {
    return undefined;
  }
  const dateRange = params.dateRange;
  if ("date" in dateRange) {
    return dateRange.date;
  }
  return "endDate" in dateRange ? dateRange.endDate : undefined;
};
